import A11yDialog from 'Carbon.Dialog/Resources/Private/Assets/Main.js';
import setPushState from 'Carbon.Frontend/Resources/Private/Assets/Scripts/setPushState';
import camelCase from 'Carbon.Frontend/Resources/Private/Assets/Scripts/camelCase';
import Gator from 'gator';

let dialog = {};
let intervalTimer;

Gator(_gg.html).on('click', 'a[data-a11y-dialog-show]', function (event) {
    event.preventDefault();
});

function iFrameSize(iFrame) {
    if (
        iFrame &&
        iFrame.contentWindow &&
        iFrame.contentWindow.document &&
        iFrame.contentWindow.document.body
    ) {
        const SCROLL_HEIGHT = iFrame.contentWindow.document.body.scrollHeight;
        if (iFrame.scrollHeight != SCROLL_HEIGHT) {
            iFrame.style.height = 0;
            iFrame.style.height = SCROLL_HEIGHT + 'px';
        }
    }
}

function iFramesSizes(iframes) {
    for (let index = 0; index < iframes.length; index++) {
        iFrameSize(iframes[index]);
    }
}

function iFramesSizesFromSection(section = document) {
    iFramesSizes(section.querySelectorAll('iframe'));
}

function dialogIframeResizeInterval(dialog) {
    dialogIframeResizeClearInterval();
    iFramesSizesFromSection(dialog);
    intervalTimer = setInterval(function () {
        iFramesSizesFromSection(dialog);
    }, 1000);
}

function dialogIframeResizeClearInterval() {
    clearInterval(intervalTimer);
}

_gg.domReady(() => {
    let dialogs = document.querySelectorAll('.dialog');

    for (let index = 0; index < dialogs.length; index++) {
        let dialog = dialogs[index];
        const ID = dialog.id ? camelCase(dialog.id) : index;
        dialog[ID] = new A11yDialog(dialog);
        dialog[ID].on('show', dialogIframeResizeInterval);
        dialog[ID].on('hide', dialogIframeResizeClearInterval);
    }

    setTimeout(function () {
        const ID_TO_OPEN = camelCase(location.hash.substr(1));
        if (ID_TO_OPEN && dialog[ID_TO_OPEN]) {
            dialog[ID_TO_OPEN].show();
            setPushState();
        }
    }, 10);
});
